import { defineMessages } from 'react-intl';

export default defineMessages({
    product: {
        id: 'app.components.defaultCourses.product',
        defaultMessage: 'Product'
    },
    country: {
        id: 'app.components.defaultCourses.country',
        defaultMessage: 'Country'
    },
    state: {
        id: 'app.components.defaultCourses.state',
        defaultMessage: 'State'
    },
    selectCourse: {
        id: 'app.components.defaultCourses.selectCourse',
        defaultMessage: 'Select course'
    },
    year: {
        id: 'app.components.defaultCourses.year',
        defaultMessage: 'YEAR'
    },
    courses: {
        id: 'app.components.defaultCourses.courses',
        defaultMessage: 'COURSES'
    },
    back: {
        id: 'app.components.defaultCourses.back',
        defaultMessage: 'Back'
    },
    save: {
        id: 'app.components.defaultCourses.save',
        defaultMessage: 'Save'
    },
    noCourse: {
        id: 'app.components.defaultCourses.noCourse',
        defaultMessage: 'No default option set'
    }
});



// WEBPACK FOOTER //
// ./app/components/default-courses/messages.js